import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";

type QuizDTO = {
  message: string;
} & ApiError;

export const SkipQuiz = (courseId: string): Promise<QuizDTO> => {
  return axios
    .patch(`/course/skipQuiz/${courseId}`)
    .then((response) => response.data as QuizDTO);
};
